import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef, MatTableDataSource} from '@angular/material';
import {DetalleCfeComponent} from '../../popups/detalle-cfe/detalle-cfe.component';
import {DetalleCFEDTO} from '../../../models/dtos/DetalleCFEDTO';
import {DatosInicioDetallesDTO} from '../../../models/dtos/datosInicio/DatosInicioDetallesDTO';
import {DatosDetalleCFEDTO} from '../../../models/dtos/datosInicio/DatosDetalleCFEDTO';
import {DatosInicioDetalleCFEDTO} from '../../../models/dtos/datosInicio/DatosInicioDetalleCFEDTO';
import {TipoRetencionDTO} from '../../../models/dtos/TipoRetencionDTO';
import {ReferenciaCFEDTO} from '../../../models/dtos/ReferenciaCFEDTO';
import {ReceptorCFEDTO} from '../../../models/dtos/ReceptorCFEDTO';
import {EmisionCfeService} from '../../services/emision-cfe.service';
import {ConfirmationComponent} from '../../popups/confirmation/confirmation.component';

@Component
({
  selector: 'app-detalles',
  templateUrl: './detalles.component.html',
  styleUrls: ['./detalles.component.scss']
})
export class DetallesComponent implements OnInit
{
  // Modelo para esta componente.
  @Input()
  detallesCFEsDTOs: Array<DetalleCFEDTO>;

  @Input()
  datosInicioDetallesDTO: DatosInicioDetallesDTO;

  @Input()
  receptorCFEDTO: ReceptorCFEDTO;

  @Input()
  tipoCFESeleccionado: number;

  // Evento dummy para actualizar los totales.
  @Output()
  actualizarTotalesEvent: any = new EventEmitter<any>();

  detallesCFEsDTOsDataSource: MatTableDataSource<DetalleCFEDTO> = null;
  emisorEsLiteralE = false;

  constructor(public detalleCFEMatDialog: MatDialog, public confirmationMatDialog: MatDialog, private emisionCfeService: EmisionCfeService,)
  {
    this.detallesCFEsDTOsDataSource = new MatTableDataSource<DetalleCFEDTO>();
    this.detallesCFEsDTOsDataSource.data = this.detallesCFEsDTOs;
  }

  ngOnInit()
  {
  }

  private armarDatosDetalleCFEDTO(detalleCFEDTO: DetalleCFEDTO, esAlta: boolean): DatosDetalleCFEDTO
  {
    const datosDetalleCFEDTO: DatosDetalleCFEDTO = new DatosDetalleCFEDTO();

    const datosInicioDetalleCFEDTO: DatosInicioDetalleCFEDTO = new DatosInicioDetalleCFEDTO();
    datosInicioDetalleCFEDTO.esModoEResguardo = this.datosInicioDetallesDTO.esModoEResguardo;
    datosInicioDetalleCFEDTO.impuestosDTOs = this.datosInicioDetallesDTO.impuestosDTOs;
    datosInicioDetalleCFEDTO.tiposRetencionesDTOs = this.datosInicioDetallesDTO.tiposRetencionesDTOs;
    datosInicioDetalleCFEDTO.tiposCFEsDTOs = this.datosInicioDetallesDTO.tiposCFEsDTOs;
    datosInicioDetalleCFEDTO.tiposPesoDTOs = this.datosInicioDetallesDTO.tiposPesoDTOs;

    if (esAlta)
    {
      datosInicioDetalleCFEDTO.codigoImpuestoSeleccionado = null;
      datosInicioDetalleCFEDTO.codigoTipoRetencionSeleccionado = null;
      datosInicioDetalleCFEDTO.codigoTipoCFESeleccionado = null;
    }
    else
    {
      if (this.datosInicioDetallesDTO.esModoEResguardo)
      {
        datosInicioDetalleCFEDTO.codigoImpuestoSeleccionado = null;
        datosInicioDetalleCFEDTO.codigoTipoRetencionSeleccionado = detalleCFEDTO.tipoRetencionEResg.codigo;
        datosInicioDetalleCFEDTO.codigoTipoCFESeleccionado = detalleCFEDTO.referenciaCFEEResg.tipoCFE !== undefined ? detalleCFEDTO.referenciaCFEEResg.tipoCFE.codigo : null;
      }
      else
      {
        datosInicioDetalleCFEDTO.codigoImpuestoSeleccionado = detalleCFEDTO.impuesto.codigo;
        datosInicioDetalleCFEDTO.codigoTipoRetencionSeleccionado = null;
        datosInicioDetalleCFEDTO.codigoTipoCFESeleccionado = null;
      }
    }

    datosDetalleCFEDTO.datosInicioDetalleCFEDTO = datosInicioDetalleCFEDTO;
    datosDetalleCFEDTO.detalleCFEDTO = detalleCFEDTO;
    datosDetalleCFEDTO.tiposCodigosIniciales = this.datosInicioDetallesDTO.tiposCodigosDTOs;
    datosDetalleCFEDTO.esRut = this.receptorCFEDTO.tipoDocumento.descripcion === 'RUT';
    datosDetalleCFEDTO.datosInicioDetalleCFEDTO.codigoTipoCFESeleccionado = this.tipoCFESeleccionado;

    return datosDetalleCFEDTO;
  }

  public agregarDetalleCFE(): void
  {
    const detalleCFEDTO: DetalleCFEDTO = new DetalleCFEDTO();
    detalleCFEDTO.referenciaCFEEResg = new ReferenciaCFEDTO();

    const matDialogConfig: MatDialogConfig = new MatDialogConfig();
    matDialogConfig.minHeight = '10px';
    matDialogConfig.minWidth = '10px';
    matDialogConfig.maxWidth = '710px';
    matDialogConfig.disableClose = true;
    matDialogConfig.data = this.armarDatosDetalleCFEDTO(detalleCFEDTO, true);

    const detalleCFEMatDialogRef = this.detalleCFEMatDialog.open(DetalleCfeComponent, matDialogConfig);
    detalleCFEMatDialogRef.afterClosed().subscribe(detalleCFENuevoDTO =>
    {
      if (detalleCFENuevoDTO !== null)
      {
        console.log(detalleCFENuevoDTO)
        this.detallesCFEsDTOs.push(detalleCFENuevoDTO);
        this.detallesCFEsDTOsDataSource.data = this.detallesCFEsDTOs;
        this.actualizarTotales();
      }
    });
  }

  public modificarDetalleCFE(detalleCFEDTO: DetalleCFEDTO): void
  {
    this.datosInicioDetallesDTO.indiceDetalleCFESeleccionado = this.detallesCFEsDTOs.indexOf(detalleCFEDTO);
    const detalleCFEClonDTO: DetalleCFEDTO = Object.assign(new DetalleCFEDTO(), detalleCFEDTO);

    const matDialogConfig: MatDialogConfig = new MatDialogConfig();
    matDialogConfig.minHeight = '10px';
    matDialogConfig.minWidth = '10px';
    matDialogConfig.maxWidth = '710px';
    matDialogConfig.disableClose = true;
    matDialogConfig.data = this.armarDatosDetalleCFEDTO(detalleCFEClonDTO, false);

    const detalleCFEMatDialogRef = this.detalleCFEMatDialog.open(DetalleCfeComponent, matDialogConfig);
    detalleCFEMatDialogRef.afterClosed().subscribe(detalleCFEModificadoDTO =>
    {
      if (detalleCFEModificadoDTO !== null)
      {
        this.detallesCFEsDTOs[this.datosInicioDetallesDTO.indiceDetalleCFESeleccionado] = detalleCFEModificadoDTO;
        this.detallesCFEsDTOsDataSource.data = this.detallesCFEsDTOs;
        this.actualizarTotales();
      }
    });
  }

  public eliminarDetalleCFE(detalleCFEDTO: DetalleCFEDTO): void
  {
    const matDialogConfig: MatDialogConfig = new MatDialogConfig();
    matDialogConfig.minHeight = '10px';
    matDialogConfig.minWidth = '10px';
    matDialogConfig.disableClose = true;
    matDialogConfig.data = 'Realmente desea eliminar el detalle seleccionado?';

    const confirmationMatDialogRef = this.confirmationMatDialog.open(ConfirmationComponent, matDialogConfig);
    confirmationMatDialogRef.afterClosed().subscribe(seConfirmo =>
    {
      if (seConfirmo === true)
      {
        this.datosInicioDetallesDTO.indiceDetalleCFESeleccionado = this.detallesCFEsDTOs.indexOf(detalleCFEDTO);
        this.detallesCFEsDTOs.splice(this.datosInicioDetallesDTO.indiceDetalleCFESeleccionado, 1);
        this.detallesCFEsDTOsDataSource.data = this.detallesCFEsDTOs;
        this.actualizarTotales();
      }
    });
  }

  public limpiarDetallesCFEs(): void
  {
    this.detallesCFEsDTOs.length = 0;
    this.detallesCFEsDTOsDataSource.data = this.detallesCFEsDTOs;
    this.actualizarTotales();
  }

  private actualizarTotales(): void
  {
    this.actualizarTotalesEvent.emit(null);
  }

  public limpiar(): void
  {
    this.detallesCFEsDTOs.length = 0;
    this.detallesCFEsDTOsDataSource.data = this.detallesCFEsDTOs;
    this.datosInicioDetallesDTO.indiceDetalleCFESeleccionado = null;
  }

  public obtenerCodigoCompuestoTipoRetencion(tipoRetencionDTO: TipoRetencionDTO): string
  {
    const codigoCompuestoRetencion: string = tipoRetencionDTO.numeroForm.toString().padStart(4, '0') + tipoRetencionDTO.cLinea.toString().padStart(3, '0');

    return codigoCompuestoRetencion;
  }

  mostrarDescripcionImpuesto(descripcion: string) {
    this.emisorEsLiteralE = this.emisionCfeService.getEmisorCFEDTO().esLiteralE;
    if (this.emisorEsLiteralE) {
      return 'Literal E';
    } else {
      return descripcion;
    }
  }
}
